module.exports = __webpack_public_path__ + "static/media/Minal Pic.b9211263.jpg";